import { type ActionImpactV1, ActionImpactV1Schema } from "@adpilot/shared";
import { api } from "./api";

export async function fetchActionImpact(actionId: string): Promise<ActionImpactV1> {
  const response = await api
    .get(`ai-actions/${actionId}/impact`)
    .json<{ success: true; data: unknown }>();
  return ActionImpactV1Schema.parse(response.data);
}
